import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { Report8, DataByAccount, DynReportService, ReportPeriod, GroupCode, ReportFilter } from '../shared';
import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { TreeNode, Message, SelectItem, UIChart } from "primeng/primeng";

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'bp-dyn-report',
  templateUrl: './dyn-report8.component.html',
  styleUrls: ['./dyn-report8.component.css'],
  providers: []
})

export class DynReport8Component implements OnDestroy, OnInit, AfterViewInit {

  @Input() reportName: string;

  private dbResetSubscription: Subscription;
  private id: any;

  @ViewChildren('scroll') scroll: QueryList<any>;
  //@ViewChild('structGraph') set content(content: UIChart) {
  //  this.structGraph = content;
  //  if (this.structGraph != null && this.structGraph.chart != null) {
  //    console.log('this.structGraph.chart', this.structGraph.chart);
  //    this.structGraphLegend = this.structGraph.chart;
  //    //this.structGraph.chart.generateLegend();
  //  }
  //}

  selectedRow: TreeNode;
  filter: ReportFilter;
  infos: Message[];
  report: Report8;
  //periodss: ReportPeriod[];
  selectedYear: SelectItem;
  selectedPeriod: ReportPeriod;
  groups: GroupCode[];
  selectedGroup: GroupCode = { value: "", text: "-" };

  budgetExeGraphData: any;
  budgetStructGraphData: any;
  structGraphLegend: any;
  top5incomesGraphData: any;



  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private reportService: DynReportService,
    private toastService: ToastService) {
  }

  private getReport(id: number, selectedGroup: string) {
    this.reportService.getReport8(id, selectedGroup)
      .subscribe(report => {
        this.report = report;
        this.budgetExeGraphData = this.reportService.buildBudgetExeGraphData8(this.report.graphData);
        this.budgetStructGraphData = this.reportService.buildBudgetStructGraphData8(this.report.graphData);
        this.top5incomesGraphData = this.reportService.buildTop5incomesGraphData8(this.report.topIncomes);
       
      });
  }

  private getYears() {
    this.reportService.getReport8Years()
      .subscribe(filter => {
        this.filter = filter;
      });
  }

  private getPeriods() {
    this.reportService.getReport8Periods(this.selectedYear.value)
      .subscribe(filter => {
        if (this.filter) {
          this.filter.periods = filter.periods;
        } else {
          this.filter = filter;
        }
      });
  }

  private gotoReports() {
    this.router.navigate(['/reports']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }

  ngOnInit() {
    //this.getPeriods();
    this.getYears();
  }

  ngAfterViewInit() {
    this.scroll.changes.subscribe((ellist: QueryList<any>) => {
      if (ellist.length > 0) {
        ellist.forEach((e, idx) => {
          if (!e.nativeElement['mcs']) {
            $(e.nativeElement).mCustomScrollbar("destroy");

            $(e.nativeElement).mCustomScrollbar({
              axis: "x",
              advanced: {
                updateOnContentResize: true
              },
              theme: "dark-thin",
              scrollButtons: {
                enable: true
              },
              contentTouchScroll: 2
            });
          }
        });
      }
    });
  }

  ngOnDestroy() {
  }

  showReport(event: Event) {
    this.getReport(this.selectedPeriod.id, this.selectedGroup.value);
  }

  nodeSelect(event) {
    if (event.node && event.node.children && event.node.children.length > 0) {
      if (event.node.expanded == false)
        event.node.expanded = true;
      else
        event.node.expanded = false;
    }
  }

  nodeUnselect(event) {
    if (event.node && event.node.children && event.node.children.length > 0) {
      event.node.expanded = false;
    }
  }

  periodChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.groups = this.selectedPeriod.groups;
  }
  reportYearChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.selectedPeriod = null;
    this.getPeriods();

  }
}



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-report/dyn-report8.component.ts